/** The `feature` attribute on every Start Strong after-SAP New Relic event and Sentry report. */
export const START_STRONG_FEATURE = 'start_strong_after_sap';
